import FileCopyIcon from '@mui/icons-material/FileCopy'
import GetAppIcon from '@mui/icons-material/GetApp'
import { Box, Checkbox, IconButton, TableCell, TableRow, Tooltip } from '@mui/material'
import { useTranslate } from 'ra-core'
import { MouseEvent } from 'react'
import { RootNodesQuery } from '../../../apollo/configurator/queries/RootNodes.generated'
import { formatDate, parseVersion } from '../utils/modelUtils'

type ModelNode = RootNodesQuery['configuratorNodes'][0]

interface ModelListTableRowProps {
    model: ModelNode
    isSelected: boolean
    onSelectClick: (id: string) => void
    onExportClick: (e: MouseEvent<HTMLButtonElement>, id: string) => void
    onDuplicateClick: (e: MouseEvent<HTMLButtonElement>, id: string) => void
    onRowClick: (id: string) => void
}

export const ModelListTableRow: React.FC<ModelListTableRowProps> = ({
    model,
    isSelected,
    onSelectClick,
    onExportClick,
    onDuplicateClick,
    onRowClick
}) => {
    const translate = useTranslate()
    const labelId = `enhanced-table-checkbox-${model.id}`

    const cellStyles = {
        px: 2,
        py: 0.75
    }

    const statusCellStyles = {
        ...cellStyles,
        color: model.is_edited ? 'warning.dark' : 'success.main'
    }

    return (
        <TableRow
            key={model.id}
            hover
            onClick={() => onRowClick(model.id.toString())}
            role="row"
            tabIndex={-1}
            selected={isSelected}
            sx={{ cursor: 'pointer' }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(e) => {
                        e.stopPropagation()
                        onSelectClick(model.id.toString())
                    }}
                    inputProps={{
                        'aria-labelledby': labelId
                    }}
                />
            </TableCell>

            <TableCell sx={cellStyles} id={labelId}>
                {model.code}
            </TableCell>

            <TableCell sx={cellStyles}>{parseVersion(model.node_attributes)}</TableCell>

            <TableCell sx={cellStyles}>{formatDate(model.updated_at)}</TableCell>

            <TableCell sx={statusCellStyles}>
                {model.is_edited ? 'Pending changes' : 'Published'}
            </TableCell>

            <TableCell sx={cellStyles}>
                <Box display="flex" gap={1}>
                    <Tooltip title={translate('manager.resources.model_manager.actions.export')}>
                        <IconButton
                            size="small"
                            onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                e.stopPropagation()
                                onExportClick(e, model.id.toString())
                            }}
                        >
                            <GetAppIcon />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title={translate('manager.resources.model_manager.actions.duplicate')}>
                        <IconButton
                            size="small"
                            onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                e.stopPropagation()
                                onDuplicateClick(e, model.id.toString())
                            }}
                        >
                            <FileCopyIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </TableCell>
        </TableRow>
    )
}
